import { render, staticRenderFns } from "./CarNumber.vue?vue&type=template&id=6fe9b4cb"
import script from "./CarNumber.vue?vue&type=script&lang=ts"
export * from "./CarNumber.vue?vue&type=script&lang=ts"
import style0 from "./CarNumber.vue?vue&type=style&index=0&id=6fe9b4cb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports